import { useEffect } from 'react';

import { generatePageTitle, PAGE_TITLES, resetPageTitle, setPageTitle } from '@/utils/page-title';

/**
 * Custom hook for setting page titles
 */
export function usePageTitle(
  title: string | keyof typeof PAGE_TITLES,
  context?: Record<string, string | number>,
  includeAppName: boolean = true
) {
  useEffect(() => {
    let finalTitle: string;

    // If title is a key from PAGE_TITLES, use the corresponding value
    if (typeof title === 'string' && title in PAGE_TITLES) {
      finalTitle = PAGE_TITLES[title as keyof typeof PAGE_TITLES];
    } else {
      finalTitle = title as string;
    }

    // Generate title with context if provided
    if (context) {
      finalTitle = generatePageTitle(finalTitle, context);
    }

    setPageTitle(finalTitle, includeAppName);

    // Reset title when component unmounts
    return () => {
      resetPageTitle();
    };
  }, [title, context, includeAppName]);
}
